<template>
  <div>
    <div id="dropin-container" />

    <div class="my-30">
      <button ref="submit-order-btn" class="btn btn-primary btn-lg" type="button">
        Complete Order
      </button>
    </div>
  </div>
</template>

<script>
import * as Toastr from "toastr";

export default {
  name: 'AppCheckoutManualBraintree',
  props: {
    braintreeClientToken: {
      type: String,
      required: true
    },
    checkoutPath: {
      type: String,
      required: true
    },
    statusPath: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.initBraintree();
  },
  methods: {
    initBraintree() {
      var that = this
      var button = this.$refs['submit-order-btn'];

      braintree.dropin.create(
      {
        authorization: this.braintreeClientToken,
        container: "#dropin-container",
        dataCollector: true,
      },
      (createErr, instance) => {
        if(createErr) {
          console.log(createErr);
          Toastr.error(
            "Unable to load payment form. Please try again.",
            "Payment error."
          );
          return;
        }

        button.addEventListener("click", function () {
          
          button.textContent = "Loading ...";
          instance.requestPaymentMethod(function (error, payload) {
            if (error) {
              button.disabled = false;
              button.textContent = "Complete Order";
              instance.clearSelectedPaymentMethod();
              Toastr.error(
                "There was error with your payment. " +
                  error.message +
                  " Please try again.",
                "Payment error."
              );
              that.showErrors();
            } else {
              $.ajax({
                method: "POST",
                data: {
                  payment_method_nonce: payload.nonce,
                  device_data: payload.deviceData,
                },
                url: that.checkoutPath,
                success: function (data) {
                  Toastr.success(
                    "Thank you for your payment, your order will be processed.",
                    "Payment successful"
                  );
                  window.location.href = that.statusPath;
                },
                error: function(request) {
                  Toastr.error(
                    'There was an error with your payment. ',
                    'Payment error',
                  )
                  
                  button.disabled = false;
                  button.textContent = "Complete Order";
                }
              })
            }
          });
        });
      }
    );
    }
  }
}
</script>